/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */

/* globals
	createDemoTabs, setTimeout, ClassicEditor, InlineEditor, BalloonEditor, DecoupledEditor, MultiRootEditor, KeyboardEvent, window
*/

createDemoTabs( '#source-editing-enhanced-editors-demo', [
	{
		EditorCreator: ClassicEditor,
		contentElementId: '#editor-classic',
		getToolbar: editor => editor.ui.view.toolbar,
		onConfig: config => {
			config.toolbar.items = [
				'undo', 'redo',
				'|', 'sourceEditingEnhanced',
				'|', 'heading',
				'|', 'bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', 'code',
				'-', 'link', 'insertImage', 'insertTable', 'blockQuote', 'mediaEmbed', 'codeBlock',
				'|', 'alignment',
				'|', 'bulletedList', 'numberedList', 'todoList', 'outdent', 'indent'
			];
		},
		onChange( { attachTourBalloon } ) {
			attachTourBalloon();
		}
	},
	{
		EditorCreator: InlineEditor,
		contentElementId: '#editor-inline',
		getToolbar: editor => editor.ui.view.toolbar,
		onConfig: config => {
			config.toolbar.items = [
				'undo', 'redo',
				'|', 'sourceEditingEnhanced',
				'|', 'heading',
				'|', 'bold', 'italic', 'underline',
				'|', 'link', 'insertImage', 'insertTable', 'blockQuote',
				'|', 'bulletedList', 'numberedList'
			];
		},
		onReady( { editor, getTourBalloonInstance } ) {
			editor.ui.view.panel.on( 'change:isVisible', ( evt, name, isVisible ) => {
				if ( !isVisible ) {
					getTourBalloonInstance().hide();
				}
			} );
		},
		onChange( { editor, attachTourBalloon } ) {
			setTimeout( () => {
				editor.focus();
				attachTourBalloon();
			}, 100 );
		}
	},
	{
		EditorCreator: BalloonEditor,
		contentElementId: '#editor-balloon',
		getToolbar: editor => editor.plugins.get( 'BalloonToolbar' ).toolbarView,
		onConfig: config => {
			config.toolbar.items = [
				'undo', 'redo',
				'|', 'sourceEditingEnhanced',
				'|', 'heading',
				'|', 'bold', 'italic', 'underline',
				'|', 'link', 'insertImage', 'insertTable',
				'|', 'bulletedList', 'numberedList'
			];
		},
		onChange( { editor, attachTourBalloon } ) {
			setTimeout( () => {
				editor.model.change( writer => {
					writer.setSelection( editor.model.document.getRoot(), 0 );
				} );

				// Alt+F10 to display the toolbar.
				editor.keystrokes.press( new KeyboardEvent( 'keydown', { keyCode: 121, altKey: true } ) );

				// Focus the button because opening the toolbar focuses the first one by default and it looks odd when
				// one is focused and the other is an anchor for the tour balloon.
				attachTourBalloon( true );
			}, 50 );
		}
	},
	{
		EditorCreator: DecoupledEditor,
		contentElementId: '#editor-document',
		getToolbar: editor => editor.ui.view.toolbar,
		onConfig: config => {
			config.toolbar.items = [
				'undo', 'redo',
				'|', 'sourceEditingEnhanced',
				'|', 'heading',
				'|', 'bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', 'code',
				'-', 'link', 'insertImage', 'insertTable', 'blockQuote', 'mediaEmbed', 'codeBlock',
				'|', 'alignment',
				'|', 'bulletedList', 'numberedList', 'todoList', 'outdent', 'indent'
			];

			config.menuBar = {
				isVisible: true
			};
		},
		onReady( { editor } ) {
			editor.editing.view.getDomRoot().parentNode.before( editor.ui.view.toolbar.element );
			editor.ui.view.toolbar.element.before( editor.ui.view.menuBarView.element );
		},
		onChange( { attachTourBalloon } ) {
			attachTourBalloon();
		}
	},
	{
		EditorCreator: MultiRootEditor,
		contentElementId: {
			top: '#editor-multi-root-top',
			middle: '#editor-multi-root-middle',
			bottom: '#editor-multi-root-bottom'
		},
		getToolbar: editor => editor.ui.view.toolbar,
		onConfig: config => {
			config.initialData = {
				top: window.initialData[ 0 ],
				middle: window.initialData[ 1 ],
				bottom: window.initialData[ 2 ]
			};
			config.toolbar.items = [
				'undo', 'redo',
				'|', 'sourceEditingEnhanced',
				'|', 'heading',
				'|', 'bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', 'code',
				'-', 'link', 'insertImage', 'insertTable', 'blockQuote', 'mediaEmbed', 'codeBlock',
				'|', 'alignment',
				'|', 'bulletedList', 'numberedList', 'todoList', 'outdent', 'indent'
			];
		},
		onReady( { editor } ) {
			const toolbarElement = editor.ui.view.toolbar.element;
			editor.editing.view.getDomRoot( 'top' ).before( toolbarElement );

			toolbarElement.style.top = editor.ui.viewportOffset.top + 'px';
		},
		onChange( { attachTourBalloon } ) {
			attachTourBalloon();
		}
	}
] );
